module.exports = __webpack_public_path__ + "static/media/empty-thumbnail.78a8eb1e.svg";